module.exports = __webpack_public_path__ + "img/like-green.75227da1.svg";